(function () {
    'use strict';

    angular.module('modules.chat', ['modules.chat.intercom', 'modules.chat.velaro', 'modules.chat.zendesk']);
})();
